/**
 * Function that handles the behavior of the footer.
 */
export default function footerTemplate() {
    const backToTopButton = document.querySelector('[data-js="back-to-top"]');
    if (!backToTopButton) {
        return;
    }

    backToTopButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
}